<template>
  <v-app-bar
    app
    flat
    height="80"
    class="naj-header"
    color="#fff"
  >
    <v-row class="container-fluid">
      <v-col
        cols="2"
        class="pa-0"
      >
        <div class="logo">
          <img src="@/assets/images/logo-dark.svg">
        </div>
      </v-col>
      <v-col
        cols="4"
        class="text-right"
      >
      </v-col>
      <v-col cols="6">
        <naj-header-menu></naj-header-menu>
      </v-col>
    </v-row>
  </v-app-bar>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import NajHeaderMenu from '@/modules/global/components/naj-header-menu';
const { mapState, mapActions } = createNamespacedHelpers('GlobalModule');

export default {
  name: 'NajHeader',
  components: { NajHeaderMenu },
  data() {
    return {};
  },
  computed: {},
  mounted() {
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/partials/_vars.scss";
.logo {
  padding: 10px 0;
  background-color: transparent;
  transition: all 0.1s ease-out;
  img {
    max-height: 50px;
    width: auto;
  }
}
.naj-header {
  left: 0 !important;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
  ::v-deep .v-toolbar__content {
    justify-content: space-between;
  }
}

.v-sheet.v-app-bar.v-toolbar {
  z-index: 100;
}
</style>
